import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material";

export const useStyles = makeStyles((theme: Theme) => ({
    "@global": {
        "@keyframes modalAppear": {
            "0%": {
                opacity: 0,
                transform: "translate(-50%, -50%) scale(0.1)",
            },
            "10%": {
                opacity: 0,
                transform: "translate(-50%, -50%) scale(0.1)",
            },
            "100%": {
                opacity: 1,
                transform: "translate(-50%, -50%) scale(1)",
            },
        },
        "@keyframes titleGlow": {
            "0%": {
                filter: "drop-shadow(0 0 0.1rem #aaa)",
            },
            "50%": {
                filter: "drop-shadow(0 0 0.5rem #888)",
            },
            "100%": {
                filter: "drop-shadow(0 0 0.1rem #aaa)",
            },
        },
        "@keyframes placeNumberPulse": {
            "0%": {
                transform: "scale(1)",
                color: "#444",
            },
            "50%": {
                transform: "scale(1.05)",
                color: "#555",
            },
            "100%": {
                transform: "scale(1)",
                color: "#444",
            },
        },
    },
    '@keyframes shimmerGreen': {
        from: { backgroundPosition: '200% center' },
        to: { backgroundPosition: '-200% center' },
    },
    modalContent: {
        backgroundColor: "rgba(20, 20, 20, 0.8)", 
        borderRadius: 20,
        padding: 5,
        maxWidth: 700,
        maxHeight: 500,
        height: "100%",
        width: "100%",
        boxShadow: "0 8px 40px rgba(0, 0, 0, 0.25)", 
        textAlign: "center",
        margin: "auto",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        outline: "none",
        border: "1px solid silver",
        background: "linear-gradient(180deg, rgba(20, 20, 20, 0.9) 0%, rgba(0, 0, 0, 0.95) 80%, rgba(0, 0, 0, 1) 100%)",
        backdropFilter: "blur(12px)",
        animation: "modalAppear 600ms ease-out forwards",

        [theme.breakpoints.down("sm")]: {
            width: "85vw",
            padding: 5,
        },
    },

    modalDescription: {
        display: 'flex',
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
    },

    modalTitle: {
        fontSize: 28,
        fontWeight: 600,
        marginBottom: 5,
        color: "#fff",
        textShadow: "0 0 4px rgba(0,0,0,0.8)",
        fontFamily: "Montserrat, sans-serif",
        animation: "titleGlow 3s infinite ease-in-out",
        [theme.breakpoints.down("sm")]: {
            fontSize: 24,
        },
    },
    tournamentName: {
        fontSize: 40,
        fontWeight: 500,
        marginBottom: 5,
        color: "#555",
        background: "linear-gradient(180deg, #666 0%, #888 100%)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        backgroundClip: "text",
        textShadow: "0.5px 0.5px 1px rgba(0, 0, 0, 0.1)",
        fontFamily: "Montserrat, sans-serif",
        [theme.breakpoints.down("sm")]: {
            fontSize: 18,
        },
    },
    placeResult: {
        marginBottom: 5,
        padding: 5,
        backdropFilter: "blur(5px)",
    },
    placeLabel: {
        fontSize: 16,
        color: "#666",
        marginBottom: 5,
        fontFamily: "Montserrat, sans-serif",
        textTransform: "uppercase",
        letterSpacing: "1px",
    },
    placeNumber: {
        fontSize: 32,
        fontWeight: 700,
        color: "#444",
        fontFamily: "Montserrat",
        textShadow: "1px 1px 2px rgba(0, 0, 0, 0.1)",
        animation: "placeNumberPulse 2s infinite ease-in-out, shimmerGradient 4s infinite linear",
        background: "linear-gradient(90deg, #6eff95, #34d774, #6eff95)",
        backgroundSize: "200% auto",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        backgroundClip: "text",
        [theme.breakpoints.down("sm")]: {
            fontSize: 28,
        },
    },
    encouragement: {
        fontSize: 16,
        color: "#777",
        marginTop: 5,
        marginBottom: 5,
        fontFamily: "Montserrat",
        opacity: 0.8,
        [theme.breakpoints.down("sm")]: {
            fontSize: 14,
        },
    },
    closeButton: {
        position: "absolute",
        top: 15,
        right: 15,
        width: 32,
        height: 32,
        backgroundColor: "transparent",
        border: "none",
        cursor: "pointer",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "all 0.2s ease",
        "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.05)",
        },
        "&::before": {
            content: '""',
            position: "absolute",
            width: "18px",
            height: "2px",
            backgroundColor: "#666",
            transform: "rotate(45deg)",
            borderRadius: "1px",
        },
        "&::after": {
            content: '""',
            position: "absolute",
            width: "18px",
            height: "2px",
            backgroundColor: "#666",
            transform: "rotate(-45deg)",
            borderRadius: "1px",
        },
    },
}));